import { DeadpoolUser } from '~types/index'
import { CART_MIGRABLE } from '../constants'

interface MigrableGuestCart {
  db: {
    getItem: (key: string) => string | null
  }
  customer: DeadpoolUser | null
  cartId: string | null
}

const migrableGuestCart = ({ db, customer, cartId }: MigrableGuestCart) => {
  const isPreviousCartGuest = db.getItem(CART_MIGRABLE)
  const isLogged = !!customer
  const hasPreviousCart = !!cartId
  const hasPreviousCartAndISLogged = isLogged && hasPreviousCart
  const storedCartId =
    isPreviousCartGuest && hasPreviousCartAndISLogged ? cartId : null

  return storedCartId
}

export default migrableGuestCart
